import { EClient } from "@/enums/EClient";
import { useAuthStore, useMemberStore } from "@/stores";
import { useClientStore } from "@/stores/modules/client";
import { isWeChat } from "@/utils/browser";
import { authorizeWxCode } from "@/utils/Wechart";

const navigateToLogin = (params: string = "") => {
    // #ifdef H5
    if (isWeChat()) {
        authorizeWxCode(`${window.location.origin}/pages/login/login`, params);
        return;
    }
    // #endif
    uni.navigateTo({
        url: `/pages/login/login${params ? `?state=${params}` : ""}`,
    });
};

export const switchTab = (url: string = '/') => {
    // #ifdef H5
    if (url) {
        let targetPath = url.startsWith('/') ? url : `/${url}`
        const isHash = window.location.hash.includes('#/')
        if (isHash) {
            window.location.replace(`${window.location.origin}/#${targetPath}`)
            return
        } else {
            window.location.replace(`${window.location.origin}${targetPath}`)
            return
        }
    }
    // #endif

    uni.reLaunch({
        url: url,
        fail: () => {
            uni.switchTab({
                url: url,
                fail: () => {
                    uni.navigateTo({ url: url })
                }
            })
        }
    })
}

export const loginSuccess = async ({ token, url }: { token: string, url?: string | null }) => {
    useAuthStore().setToken(token)
    try {
        await useMemberStore().setUserLevel()
    } catch (e) {
        console.error('setUserLevel error:', e)
    }
    useClientStore().setClient(useMemberStore().userLevel?.sourceType)

    // 成功提示
    uni.showToast({ icon: 'success', title: '登录成功' })

    url && switchTab(url)
}

export const tokenError = () => {
    if (useClientStore().client === EClient.BOCOM) {
        const searchStr = window.location.search.replace("?", "");
        const to = window.location.pathname.split("/").pop();
        const searchParam = searchStr
            ? `${searchStr.startsWith("&") ? searchStr : `&${searchStr}`}`
            : "";
        useClientStore().oauth(`/pages/bocom/oauth?to=${to}${searchParam}`);
    } else if (useMemberStore()?.userLevel?.sourceType === "CMCC") {
        uni.showToast({
            icon: "none",
            title: "页面已超时，请重新进入",
        });
    } else {
        uni.showToast({
            icon: "none",
            title: "页面已超时",
        });

        const ttData = uni.getStorageSync('tt')
        let isTtValid = false
        if (ttData) {
            if (typeof ttData === 'object' && ttData !== null && ttData.expire) {
                if (Date.now() > ttData.expire) {
                    uni.removeStorageSync('tt')
                } else {
                    isTtValid = true
                }
            }
        }

        if (isTtValid) {
            uni.navigateTo({ url: `/pages/sys/error` })
        } else {
            let paramUrl = "";
            let jump = true;

            // #ifdef H5
            jump = window.location.href.indexOf('/pages/login/login') < 0
            paramUrl = window.location.href.replace(window.location.origin, '')
            // #endif

            paramUrl = paramUrl === "/" ? "" : paramUrl;
            if (jump) {
                navigateToLogin(paramUrl);
            }
        }
    }
}
